module.exports = __webpack_public_path__ + "img/pc_info.5e5beb1a.png";